module.exports = __webpack_public_path__ + "img/sparkles.c9d8b79a.svg";